import * as XLSX from 'xlsx';
import { Button, Col, FormGroup, Input, Label, Row, Spinner } from "reactstrap";
import HeaderAdmin from "../../../components/HeaderAdmin/HeaderAdmin";
import "./styles.css";
import DatePicker from "react-datepicker";
import { ptBR } from "date-fns/locale";
import { useContext, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { Context } from "../../../hooks/useAuthContext";
import api from "../../../services/axiosConfig";
import AccordionNfAdmin from "./components/AccordionNfAdmin";
import { format } from "date-fns";
import Swal from "sweetalert2";
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

function NotasFiscais() {
  const { exibirLogs } = useContext(Context);
  const [mesAno, setMesAno] = useState(new Date());
  const [status, setStatus] = useState("");
  const [statusPagamento, setStatusPagamento] = useState("");
  const [tipoConta, setTipoConta] = useState("");
  const [notasNegativas, setNotasNegativas] = useState(false);
  const [buscarPendentesGeral, setBuscarPendentesGeral] = useState(false);
  const [buscarEmitidasGeral, setBuscarEmitidasGeral] = useState(false);
  const [allNotasDoMes, setAllNotasDoMes] = useState([]);
  const [notasFiscais, setNotasFiscais] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState("default");

  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);

  function handleMesAnoChange(date) {
    setMesAno(date);
  }

  function handleStatusChange(e) {
    setStatus(e.target.value);
  }

  function handleStatusPagamentoChange(e) {
    setStatusPagamento(e.target.value);
  }

  const fetchNotasFiscais = async () => {
    setLoading(true);
    try {
      const mes = String(mesAno.getMonth() + 1).padStart(2, "0");
      const ano = mesAno.getFullYear();
      const formattedDate = `${mes}/${ano}`;

      const params = { date: formattedDate };

      const response = await api.get("/nf/listar-notas", { params });
      const data = response.data || [];
      
      setAllNotasDoMes(data);
      setNotasFiscais(data);

    } catch (error) {
      exibirLogs && console.error("Erro ao buscar notas fiscais:", error);
      setAllNotasDoMes([]);
      setNotasFiscais([]);
      toast.error("Erro ao buscar notas fiscais");
      throw new Error("Erro ao buscar notas fiscais: " + error);
    } finally {
      setLoading(false);
    }
  };

  const fetchNotasFiscaisPendente = async () => {
    setLoading(true);
    try {

      const params = { status: 'pendente' };

      const response = await api.get("/nf/listar-notas", { params });
      const data = response.data || [];
      
      setAllNotasDoMes(data);
      setNotasFiscais(data);

    } catch (error) {
      exibirLogs && console.error("Erro ao buscar notas fiscais:", error);
      setAllNotasDoMes([]);
      setNotasFiscais([]);
      toast.error("Erro ao buscar notas fiscais");
      throw new Error("Erro ao buscar notas fiscais: " + error);
    } finally {
      setLoading(false);
    }
  };

  const fetchNotasFiscaisEmitidas = async () => {
    setLoading(true);
    try {

      const params = { 
        status: 'emitida',
        statusPagamento: { $ne: 'pago' }
      };

      const response = await api.get("/nf/listar-notas", { params });
      const data = response.data || [];
      
      setAllNotasDoMes(data);
      setNotasFiscais(data);

    } catch (error) {
      exibirLogs && console.error("Erro ao buscar notas fiscais:", error);
      setAllNotasDoMes([]);
      setNotasFiscais([]);
      toast.error("Erro ao buscar notas fiscais");
      throw new Error("Erro ao buscar notas fiscais: " + error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
  if (buscarPendentesGeral) {
    fetchNotasFiscaisPendente();
  } else {
    fetchNotasFiscais();
  }
}, [mesAno, buscarPendentesGeral]);

useEffect(() => {
  if (buscarEmitidasGeral) {
    fetchNotasFiscaisEmitidas();
  } else {
    fetchNotasFiscais();
  }
}, [mesAno, buscarEmitidasGeral]);

  useEffect(() => {
    let notasProcessadas = [...allNotasDoMes];
    if (searchTerm) {
      notasProcessadas = notasProcessadas.filter(nf =>
        nf.nome.toLowerCase().includes(searchTerm.toLowerCase()) ||
        nf.apelido?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    if (status && !buscarPendentesGeral) {
      notasProcessadas = notasProcessadas.filter(nf => nf.status === status);
    }
    if (statusPagamento) {
      notasProcessadas = notasProcessadas.filter(nf => nf.statusPagamento === statusPagamento);
    }
    if (notasNegativas) {
      notasProcessadas = notasProcessadas.filter(nf => nf.values.valorEmRealComDesconto < 0);
    }

    if (tipoConta) {
      notasProcessadas = notasProcessadas.filter(nf => nf.tipoConta === tipoConta);
    }
    
    if (sortConfig === 'az') {
      notasProcessadas.sort((a, b) => a.nome.localeCompare(b.nome));
    } else if (sortConfig === 'za') {
      notasProcessadas.sort((a, b) => b.nome.localeCompare(a.nome));
    }

    setNotasFiscais(notasProcessadas);

  }, [searchTerm, sortConfig, tipoConta, status, statusPagamento, notasNegativas, allNotasDoMes]);

  const handleExport = async () => {
    const result = await Swal.fire({
      title: "Exportar Notas Fiscais",
      text: `Deseja exportar ${notasFiscais.length} Nota Fiscal do Mês ${format(mesAno, "MM/yyyy", { locale: ptBR })}?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sim, exportar!",
      confirmButtonColor: "#3085d6",
      cancelButtonText: "Cancelar",
    });

    if (result.isConfirmed) {
      if (!notasFiscais || notasFiscais.length === 0) {
        toast.warn("Nenhuma nota encontrada para exportação com os filtros atuais.");
        return;
      }
      
      setLoading(true);
      toast.info("Gerando arquivo de exportação...");

      try {
        const headers = [
          "Nome", "Apelido", "E-mail", "Tipo Conta", "Telefone", "Chave Principal", "Chave Pix Secundaria",
          "Total em dólar", "Taxa do Google (%)", "Taxa plataforma (%)", "Líquido em dólar (50%)",
          "Cotação do dólar", "Valor em real", "Descontos", "Obs Descontos", "Sua parte",
          "Data para pagamento", "Status", "Status Pagamento", "_id", "urlNota"
        ];
        
        const dataToExport = notasFiscais.map(nf => {
          const { nome, apelido, email, tipoConta, telefone, chavesPix, values, status, statusPagamento, _id, urlNota } = nf;
          const chavePrincipal = chavesPix?.find(c => c.isPrincipal)?.chave || '';
          const chaveSecundaria = chavesPix?.find(c => !c.isPrincipal)?.chave || '';
          
          const { 
            totalDolar, taxaGoogle, taxaPlataforma, liquidoDolar, cotacaoDolar, 
            valorEmReal, totalDescontos, obsDesconto, valorEmRealComDesconto, dataPagamento,
          } = values;

          return [
            nome, apelido, email, tipoConta === "usuario" ? "Cortador" : tipoConta, telefone, 
            chavePrincipal, chaveSecundaria || "Nenhuma chave secundária", totalDolar, taxaGoogle, 
            taxaPlataforma || "0%", liquidoDolar, cotacaoDolar, valorEmReal, totalDescontos,
            obsDesconto, valorEmRealComDesconto, dataPagamento, status, statusPagamento, _id, 
            urlNota || "Não há NFS-E em PDF"
          ];
        });

        const worksheet = XLSX.utils.aoa_to_sheet([headers, ...dataToExport]);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Pagamentos");

        const fileName = `exportacao-pagamentos-${format(mesAno, "MM-yyyy")}.xlsx`;
        XLSX.writeFile(workbook, fileName);

        toast.success("Arquivo XLSX gerado com sucesso!");
      } catch (error) {
        if (exibirLogs) console.error("Erro ao exportar notas fiscais:", error);
        toast.error("Falha ao exportar notas fiscais.");
      } finally {
        setLoading(false);
      }
    }
  };

  const handleFileSelectAndUpdate = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    event.target.value = null;
    setLoading(true);

    toast.info("Enviando planilha para processamento...");
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await api.post("/nf/atualizar-pagamentos", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      const { notasAtualizadas, erros, totalLinhas } = response.data;
      let htmlMessage = `<b>Processamento Concluído!</b><br/><br/>Quantidade de notas: <strong>${totalLinhas || 'N/A'}</strong><br/>Notas atualizadas: <strong>${notasAtualizadas}</strong>`;
      if (erros?.length > 0) {
        htmlMessage += `<br/>Erros: <strong>${erros.length}</strong><br/><ul style="text-align: left; max-height: 150px; overflow-y: auto; margin-top: 10px;">${erros.map(e => `<li>${e}</li>`).join('')}</ul>`;
      }
      Swal.fire({
        title: "Resumo da Atualização",
        html: htmlMessage,
        icon: erros?.length > 0 ? "warning" : "success"
      });

      fetchNotasFiscais();
    } catch (error) {
      const errorMessage = error.response?.data?.error || "Falha ao enviar a planilha.";
      exibirLogs && console.error("Erro ao atualizar em massa:", error);
      toast.error(errorMessage);
      throw new Error("Erro ao atualizar notas fiscais em massa: " + error.response?.data?.error || "Erro desconhecido ao atualizar em massa:");
    } finally { setLoading(false); }
  };

  const totalReceita = notasFiscais.reduce((acc, nota) => {
    return acc + nota.values.valorEmRealComDesconto;
  }, 0)

  return (
    <div>
      <HeaderAdmin />
      <input type="file" ref={fileInputRef} onChange={handleFileSelectAndUpdate} style={{ display: "none" }} accept=".xlsx, .xls" />
      <div className="infoPage">
        <span>
          <Link to={'/'} style={{ textDecoration: 'none', color: '#000'}}>
            <FaArrowLeft size={16} /> Notas Fiscais
          </Link> 
        </span>
      </div>

      <div className="miniWrapper" style={{ marginTop: 20 }}>
        <Row style={{display: 'flex', justifyContent: 'space-between'}}>
          <Col md={2} sm={6} xs={12}>
            <FormGroup className="filterGroup">
              <Label for="mesAno">Mês trabalhado</Label>
              <DatePicker
                selected={buscarPendentesGeral || buscarEmitidasGeral ? null : mesAno}
                onChange={handleMesAnoChange}
                dateFormat="MM/yyyy"
                showMonthYearPicker
                locale={ptBR}
                className="dateInputRelatorio form-control"
                placeholderText="Todas as datas"
                id="mesAno"
                autoComplete="off"
                disabled={buscarPendentesGeral || buscarEmitidasGeral || loading}
              />
              <span className="text-mute" style={{ color: 'red', fontSize: 14}}>
                OBS: Data referente a receita da nota!
              </span>
            </FormGroup>
          </Col>

          <Col md={2} sm={6} xs={12}>
            <FormGroup className="filterGroup">
              <Label>Status</Label>
              <Input
                id="selectStatus"
                name="select"
                type="select"
                value={status}
                onChange={handleStatusChange}
                style={{ paddingTop: 8, paddingBottom: 8 }}
                disabled={buscarPendentesGeral || buscarEmitidasGeral || loading}
              >
                <option value="">Todas</option>
                <option value="pendente">Pendente</option>
                <option value="emitida">Emitida</option>
                <option value="cancelado">Cancelada</option>
              </Input>
            </FormGroup>
          </Col>

          <Col md={3} sm={6} xs={12}>
            <FormGroup className="filterGroup">
              <Label>Tipo Conta</Label>
              <Input
                id="selectTipoConta"
                name="select"
                type="select"
                value={tipoConta}
                onChange={(e) => setTipoConta(e.target.value)}
                style={{ paddingTop: 8, paddingBottom: 8 }}
              >
                <option value="">Todas</option>
                <option value="afiliado">Afiliado</option>
                <option value="usuario">Cortador</option>
                <option value="influenciador">Influenciador</option>
              </Input>
            </FormGroup>
          </Col>

          <Col md={3} sm={6} xs={12}>
            <FormGroup className="filterGroup">
              <Label>Status de Pagamento</Label>
              <Input
                id="selectStatusPagamento"
                name="select"
                type="select"
                value={statusPagamento}
                onChange={handleStatusPagamentoChange}
                style={{ paddingTop: 8, paddingBottom: 8 }}
              >
                <option value="">Todas</option>
                <option value="pendente">Pendente</option>
                <option value="pago">Pago</option>
                <option value="doacao">Doação</option>
              </Input>
            </FormGroup>
          </Col>

          <Col md={2}>
            <FormGroup className="filterGroup">
              <Label for="sort-config">Ordenar por nome</Label>
              <Input
                id="sort-config"
                name="sort-config"
                type="select"
                value={sortConfig}
                onChange={(e) => setSortConfig(e.target.value)}
              >
                <option value="default">Padrão</option>
                <option value="az">A-Z</option>
                <option value="za">Z-A</option>
              </Input>
            </FormGroup>
          </Col>
          
          {notasFiscais.length > 0 &&
            <>
              <Col md={10}>
                <FormGroup className="filterGroup">
                  <Label for="search-term">Buscar por nome ou apelido</Label>
                  <Input
                    id="search-term"
                    name="search-term"
                    placeholder="Digite o nome ou apelido..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </FormGroup>
              </Col>
              <Col md={2} sm={6} xs={12}>
                <FormGroup className="filterGroup">
                  <Label>Ação</Label>
                  <Button disabled={loading} color="secondary" onClick={() => fileInputRef.current.click()}>
                    {loading ? <><Spinner /> <span className="ml-2">Atualizando...</span></> : "Atualizar Pagamento"}
                  </Button>
                </FormGroup>
              </Col>
              <Col md={12} sm={6} xs={12}>
                <FormGroup className="filterGroup">
                  
                  <Button onClick={handleExport} disabled={loading} color="success">
                    {loading ? <><Spinner /> <span className="ml-2">Exportando...</span></> : "Exportar NFS-e"}
                  </Button>
                </FormGroup>
              </Col>
            </>
          }
        </Row>

        <div 
          style={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 
            'space-between', 
            width: '100%',
            marginTop: 20
          }}>

          <FormGroup check className="h-full" style={{ display: 'flex', gap: 45}}>
            <div>
              <Input
                id="mostrarNegativosCheckbox"
                type="checkbox"
                checked={notasNegativas}
                onChange={(e) => setNotasNegativas(e.target.checked)}
                disabled={ loading }
              />
              <Label check for="mostrarNegativosCheckbox" className="ml-2 pt-1" style={{paddingLeft: 5}}>
                Apenas notas negativas
              </Label>
            </div>

            <div>
              <Input
                id="buscarPendentesCheckbox"
                type="checkbox"
                checked={buscarPendentesGeral}
                onChange={(e) => setBuscarPendentesGeral(e.target.checked)}
                disabled={buscarEmitidasGeral || loading}
              />
              <Label check for="buscarPendentesCheckbox" className="ml-2 pt-1" style={{paddingLeft: 5}}>
              Notas pendentes de todos os meses
              </Label>
            </div>

            <div>
              <Input
                id="buscarEmitidasCheckbox"
                type="checkbox"
                checked={buscarEmitidasGeral}
                onChange={(e) => setBuscarEmitidasGeral(e.target.checked)}
                disabled={buscarPendentesGeral || loading}
              />
              <Label check for="buscarEmitidasCheckbox" className="ml-2 pt-1" style={{paddingLeft: 5}}>
              Notas Emitidas de todos os meses
              </Label>
            </div>
          </FormGroup>

          <div >
            <b>Quantidade de Notas Fiscais:</b> {notasFiscais.length }
          </div>
        </div>

        <div className='totalReceitas'>
          <span><b>Total de receitas: </b> {totalReceita.toLocaleString('pt-br', {style: 'currency', currency:'BRL'})}</span>
        </div>       
        <div style={{ marginTop: 10 }}>
          {loading ? (
             <div style={{ textAlign: "center" }}><Spinner /> Carregando...</div>
          ) : notasFiscais.length > 0 ? (
            <div>
              {notasFiscais.map((nf, index) => (
                <AccordionNfAdmin
                  key={index}
                  title={nf.nome}
                  apelido={nf.apelido}
                  id={nf._id}
                  buscarNotasFiscais={fetchNotasFiscais}
                  selectedDatePeriod={mesAno}
                  nota={nf}
                />
              ))}
            </div>
          ) : (
            <div style={{ textAlign: "center" }}>
              Não há receitas para este filtro
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default NotasFiscais;